import event from '@/event-bus/event';
import dataRoamingApi from '@/api/dataRoaming/dataRoamingApi'

export default {
    name: 'add-roam-item-alert',
    mixins: [],
    extends: {},
    components: {},
    props: ['roamItem'],
    data() { 
        return {
            progress: {
                value: 0,
                msg: '',
            },
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    beforeDestroy() {},
    methods: {
        async addRoamItem() {
            // 彈跳式窗關閉，打開loading
            this.$emit('close');
            this.setProgress(this.progress.value += 10, '漫遊開關設定中，請稍候')
            this.$bus.$emit(event.progress, this.progress);
            
            // 查詢大開關狀態
            let dataBasicStatus = await dataRoamingApi.getDataBasicStatus();

            
			 // 當前大開關關閉，執行開啟大開關
			if (dataBasicStatus.dataRoamFlag == 'N') {
                let switchDataRoamingResult = await dataRoamingApi.switchDataRoaming();
                // 開啟大開關失敗
                if(!switchDataRoamingResult){
                    // 關閉loading
                    this.$bus.$emit(event.progressClose);
                    return;
                }
			}

            let counter = 0 // 計數器，
            // 每5秒共8次檢查大開關狀態
			let getDataBasicStatusInterval = await setInterval(async () => {

                if(counter < 8 ){
                    // 查詢大開關狀態
                    dataBasicStatus = await dataRoamingApi.getDataBasicStatus();

                    // 已開啟大開關
                    if (dataBasicStatus.dataRoamFlag == 'Y') {
                        clearInterval(getDataBasicStatusInterval);
                        this.setProgress(90, '優惠服務設定中，請稍候')
                        this.$bus.$emit(event.progress, this.progress);

                        // 執行新增日租
                        delete this.roamItem.roamingOperator.countryName;
                        const ftAddRoamingItem = {
                            selectedRoamingOperator: this.roamItem.roamingOperator,
                            pickupStart: this.roamItem.pickupStart,
                            pickupEnd: this.roamItem.pickupEnd
                        }
                        let result = await dataRoamingApi.addRoamItem(ftAddRoamingItem);

                        if (result) {
                            this.setProgress(100, '優惠服務設定完成')
                            this.$bus.$emit(event.progress, this.progress);

                            this.$router.push({ name: 'gt-success', params: { returnName: 'data-roaming', title: '國際數據漫遊服務', msg: '國際數據漫遊服務已設定成功' }});
                        }
                        // 關閉loading
                        this.$bus.$emit(event.progressClose);
                    }
                    else{
                        this.$bus.$emit(event.progressValue, this.progress.value += 10);
                        counter++
                    }
                }
                // 查詢大開關失敗
                else{
                    // 關閉loading
                    this.$bus.$emit(event.progressClose);
                    clearInterval(getDataBasicStatusInterval);
                    this.$router.push({ name: 'gt-error', params: { returnName: 'data-roaming', msg: '大開關啟動失敗。' }})
                    return;
                }
            }, 5000);
        },
        setProgress(value, msg){
            this.progress.value = value;
            this.progress.msg = msg;
        },
        close() {
            this.$emit('close');
        },
    },
  };
  


// WEBPACK FOOTER //
// ./src/components/service/alert/addRoamItem-alert.js